export default "__VITE_ASSET__BXTS88PJ__"